import styles from 'styles/modules/newsAlert/Newsroom.module.scss';

// One ad per page, labelled, at a fixed size so nothing shifts as it loads.
const StorySponsor = ({ sponsor }) => (
    <aside className={styles.storySponsor} aria-label="Advertisement">
        <span className={styles.storySponsorLabel}>Advertisement</span>
        <a href={sponsor.url} target="_blank" rel="sponsored noopener">
            <img
                src={sponsor.imageUrl}
                alt={`Advertisement: ${sponsor.name}`}
                width={728}
                height={90}
            />
        </a>
    </aside>
);

export default StorySponsor;
